export const UNITS_LS_KEY = "units";
export const LOCALE_LS_KEY = "locale";
